import BmtBotActivityAPI from '../../api/bmtBotActivity';

// Sprint #46: espelha o store bmtInboxHealth (UICS). Polling 5s das
// BmtBotSessions :active, mapeadas por conversation_id (display_id) pra o
// banner do header + badge da lista saberem se ha bot/agente IA respondendo.
const POLL_INTERVAL_MS = 5000; // 5s — bot ativo precisa de latencia baixa

export const state = {
  // { [conversation_id]: { id, conversation_id, bot_id, bot_name, bot_color, ... } }
  byConversationId: {},
  lastFetchedAt: null,
  isPolling: false,
  pollTimer: null,
};

export const getters = {
  // Expoe o mapa inteiro; componentes derivam por conversation_id em computeds.
  byConversationId: $state => $state.byConversationId,
};

export const actions = {
  async fetch({ commit }) {
    try {
      const { data } = await BmtBotActivityAPI.get();
      commit('SET_ACTIVITY', data.data || []);
    } catch (error) {
      // Silencioso: se backend cair, UI nao quebra; proximo poll tenta de novo.
    }
  },
  startPolling({ state: $state, commit, dispatch }) {
    if ($state.isPolling) return;
    commit('SET_POLLING', true);
    dispatch('fetch'); // primeira chamada imediata
    const timer = setInterval(() => dispatch('fetch'), POLL_INTERVAL_MS);
    commit('SET_POLL_TIMER', timer);
  },
  stopPolling({ state: $state, commit }) {
    if ($state.pollTimer) clearInterval($state.pollTimer);
    commit('SET_POLL_TIMER', null);
    commit('SET_POLLING', false);
  },
};

export const mutations = {
  SET_ACTIVITY($state, list) {
    const map = {};
    list.forEach(item => {
      map[item.conversation_id] = item;
    });
    $state.byConversationId = map; // novo objeto => dispara reatividade
    $state.lastFetchedAt = new Date();
  },
  SET_POLLING($state, isPolling) {
    $state.isPolling = isPolling;
  },
  SET_POLL_TIMER($state, timer) {
    $state.pollTimer = timer;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
